import {useTranslation} from "react-i18next";
import 'moment-timezone';
import {Link} from "react-router-dom";
// -
import {useEffect} from "react";

const RecoveryTable = ({itemsShown}) => {
    const {t: _Tc} = useTranslation("choices");
    const {t: _Tt} = useTranslation("tags");


    const stickyHeaderStyle = {
        position: "sticky",
        top: "116px",
        backgroundColor: "white",
    };

    useEffect(() => {

    }, [])

    return (
        <>
            <div className="col-12">
                <hr className="mb-4"/>
                {!itemsShown || itemsShown.length === 0 ? (
                    <div className="alert alert-secondary text-center">{_Tt("common.noData")}</div>
                ) : (
                    <table className="table table-striped">
                        <thead>
                        <tr>
                            <th
                        key="-1"
                        style={{
                            width: "26px",
                            ...stickyHeaderStyle,
                        }}
                        className="sticky-top border-bottom-sticky ">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                        />
                    </th>
                            <td>{_Tt("container.uid")}</td>
                            <td>{_Tt("device.uuid")}</td>
                            <td>{_Tt("container.download_type")}</td>
                            <td>{_Tt("container.waste_type")}</td>
                            <td>{_Tt("container.group")}</td>
                            <td>{_Tt("container.zone")}</td>
                            <td>{_Tt("container.island")}</td>
                        </tr>
                        </thead>
                        <tbody>
                        {itemsShown.map((item, index) => (
                            <tr key={index} data-idx={index}>
                                <td><Link to={"/data-view/data-container/" + item.uid + "/"} className="slx-link">{item.uid}</Link></td>
                                <td>{item.uuids}</td>
                                <td>{_Tc("downloads." + item.download_type)}</td>
                                <td>{_Tc("wastes." + item.waste_type)}</td>
                                <td>{item.group_name}</td>
                                <td>{item.zone_name}</td>
                                <td>{item.island_name}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                )}
            </div>
        </>
    );
}

export default RecoveryTable;